import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("LoginPage");

export const loginPageActions = {
  USER_CLICKED_LOGIN_BUTTON: actionCreator<{
    username: string;
    password: string;
  }>("USER_CLICKED_LOGIN_BUTTON")
};
